import React, { useState } from 'react';
import { Marker, Popup } from 'react-leaflet';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { divIcon } from 'leaflet';
import styles from './map-controls.css';

const LocationButton = ({ mapRef }) => {
  const [currentLocation, setCurrentLocation] = useState(null);

  const customMarkerIcon = divIcon({
    className: 'custom-marker',
    html: '📍',
    iconSize: [30, 30],
    iconAnchor: [15, 30],
    popupAnchor: [0, -30]
  });

  const handleLocationClick = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          const location = [latitude, longitude];
          setCurrentLocation(location);
          
          if (mapRef.current) {
            mapRef.current.flyTo(location, 13, {
              animate: true,
              duration: 1.5
            });
          }
        },
        (error) => {
          console.error('Error getting location:', error);
        }
      );
    } else {
      console.error('Geolocation is not supported by this browser');
    }
  };

  return (
    <div 
      className={styles.container} 
      onClick={handleLocationClick}
    >
      <LocationOnIcon />
      {currentLocation && (
        <Marker position={currentLocation} icon={customMarkerIcon}>
          <Popup>You are here!</Popup>
        </Marker>
      )}
    </div>
  );
};

export default LocationButton;